import withResponsive from '../hoc/withResponsive'

export default withResponsive({
  name: 'scroll-horizontal',

  ui: {
    item: '[js-scroll-horizontal-item]',
  },

  componentDidMount () {
    this.el.scrollLeft = this.ui.item.offsetLeft - ((this.el.offsetWidth - this.ui.item.offsetWidth) / 2)
  },
})
